import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { fetchData, postData, SyncData, TripCustomerfetchData } from '../../../apiService';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Button from '@mui/material/Button';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Select from 'react-select';
import Paper from '@mui/material/Paper';
import { Tooltip, IconButton } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Link } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CircularProgress from '@mui/material/CircularProgress';

const truncate2 = (num) => Math.trunc(num * 100) / 100;

const ExtraSaleOrderCreate = () => {
    const { id, tid } = useParams();

    const history = useHistory();
    const { isAuthenticated, companyId, userId, customerid, token, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
        fetchItemsTypes();
    }, [isAuthenticated, token, logout]);

    const [data, setData] = useState(null);
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [customerName, setCustomerName] = useState('');
    const [rate, setRate] = useState('');
    const [discount, setDiscount] = useState('');
    const [singlediscount, setsingleDiscount] = useState('');
    const [GSTRate, setGSTRate] = useState('');
    const [paymentMode, setPaymentMode] = useState('');
    const [tripdate, setTripdate] = useState('');
    const [customerId, setCustomerId] = useState('');
    const [qty, setQty] = useState('');
    const [loading, setLoading] = useState(false);
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [Remarks, setRemarks] = useState("");
    const [SaleRemarks, setSaleRemarks] = useState("");
    const [items, setitems] = useState('');
    const [isReturnsale, setisReturn] = useState('');
    const [Bundle, setBundle] = useState('');
    const [Pieces, setPieces] = useState('');
    const [LastBillDate, setLastBillDate] = useState("");
    const [LastBillAmount, setLastBillAmount] = useState("");
    const [Outstanding, setOutstanding] = useState("");
    const [pricetype, setpricetype] = useState('');
    const [Route, setRoute] = useState('');
    const[addressLine1, setaddressLine1]= useState('');

    useEffect(() => {
        const fetchTripDataFromApi = async () => {
            try {
                const response = await fetchData('executiveApi', `/${id}/${tid}`, token);
                if (response.responseCode === '1111') {
                    const dataArray = response.response_data;
                    // console.error(dataArray);
                    dataArray.forEach(item => { });
                    setData(dataArray);
                    if (dataArray.length > 0) {
                        setCustomerName(dataArray[0].name);
                        setaddressLine1(dataArray[0].addressLine1);
                        setPaymentMode(dataArray[0].paymentType)
                        setTripdate(dataArray[0].orderDate);
                        setCustomerId(dataArray[0].id);
                        setpricetype(dataArray[0].customerpricetype);
                        setisReturn(dataArray[0].isReturns);
                        setLastBillDate(dataArray[0].latestBillDate);
                        setLastBillAmount(dataArray[0].latestBillAmount);
                        setOutstanding(dataArray[0].outstandingbalance);
                        setRemarks(dataArray[0].remarks);
                        setRoute(dataArray[0].route);

                    }
                }
            } catch (error) {
                console.error('Error fetching customer Data:', error);
            }
        };

        if (tid && id) {
            fetchTripDataFromApi();
        }
    }, [tid, id, token]);

    const [categoryId, setCategoryId] = useState('');
    const [productCategoryId, setPCategoryId] = useState('');
    const [itemId, setItemId] = useState('');

    const [itemOptions, setItemOptions] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);

    const [QtyBundle, setQtyBundle] = useState('');
    const [QtyItem, setQtyItem] = useState('');

   
    const fetchItemsTypes = async () => {
        try {
            const response = await fetchData('ExtraLoadingAPI', `/Item/${companyId}/${tid}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(item => ({
                    value: item.ItemId,
                    label: item.item,
                    quantity: item.quantity, // Include quantity in dropdown options
                }));
                setItemOptions(options);
            }
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    };

    const handleItemChange = async (selectedOption) => {
        setSelectedItem(selectedOption);
        const selectedItemId = selectedOption.value;
        const selectedQuantity = selectedOption.quantity; // Fetch quantity directly from selected option
        setQtyItem(selectedQuantity); // Set the initial quantity in the state

        try {
            const response = await fetchData('ItemRateCheckingApi', `/${id}/${selectedItemId}`, token);

            if (response && response.response_data?.length > 0) {
                let itemFound = false;

                response.response_data.forEach(category => {
                    if (category.Items?.length > 0) {
                        category.Items.forEach(item => {
                            if (!itemFound) {
                                const { Rate, GSTRate, Weight, Bundle, QtyBundle } = item;
                                const numericWeight = parseFloat(Weight);
                                setRate(Rate);
                                setGSTRate(GSTRate);
                                setBundle(Bundle ?? 0);
                                setQtyBundle(QtyBundle ?? 0);
                                setNewItem((prevItem) => ({
                                    ...prevItem,
                                    weight: numericWeight,
                                    rate: Rate,
                                    GSTRate: GSTRate,
                                    Bundle: Bundle ?? 0,
                                    QtyBundle: QtyBundle ?? 0,
                                    quantity: selectedQuantity, // Set quantity in the new item
                                }));
                                itemFound = true;
                            }
                        });
                    }
                });

                if (!itemFound) {
                    console.error('No items found in the response data');
                }
            } else {
                console.error('Invalid response structure');
            }
        } catch (error) {
            console.error('Error fetching item rate:', error);
        }
    };

    const [newItem, setNewItem] = useState("");

    const handleQtyChange = (e) => {
        // Remove non-numeric characters
        const input = e.target.value.replace(/\D/g, '');

        // Parse input value or default to 0
        const quantity = parseInt(input) || 0;

        // Update Qty state
        setQty(input);

        // Perform calculations only if input is valid (numeric and non-negative)
        if (quantity >= 0) {
            const gstAmount = (rate * GSTRate) / 100; // GST amount per unit
            const totalAmount = rate * quantity; // Total without GST
            const totalPlusGst = totalAmount + gstAmount; // Total including GST
            const totalQuantity = newItem.weight * quantity; // Adjust total weight

            // Update newItem state with calculated values
            setNewItem((prevItem) => ({
                ...prevItem,
                quantity: quantity,
                totalAmount: totalAmount,
                GSTRate: GSTRate,
                gstAmount: gstAmount,
                totalPlusGst: totalPlusGst,
                discount: discount,
                totalQuantity: totalQuantity,
            }));
        }
    };

    useEffect(() => {
        const quantity = parseInt(qty) || 0;
        const gstAmount = (rate * GSTRate) / 100;
        const totalAmount = rate * quantity;
        const totalPlusGst = totalAmount + gstAmount;
        const bundle = Bundle;
        //const pieceCount = quantity % newItem.Bundle;
        setNewItem((prevItem) => ({
            ...prevItem,
            rate: rate,
            totalAmount: totalAmount,
            gstAmount: gstAmount,
            totalPlusGst: totalPlusGst,
            discount: discount, // Ensure correct reference
            Bundle: bundle,
            //pieces: pieceCount,
        }));
    }, [rate, qty, discount, GSTRate, Bundle]); // Added dependencies

    const [itemList, setItemList] = useState([]);

    const defaultItem = {
        Id: '',
        Name: '',
        quantity: 1,
        GSTRate: 0,
        rate: 0,
        totalAmount: 0,
        totalPlusGst: 0,
        discount: 0,
        weight: 0,
        totalQuantity: 0,
        rateperkg: 0,
        TotalAmtperkgwise: 0,
        GstPer: 0,
        gstAmount: 0,
        TaxableAmount: 0,
        Bundle: 0,
        Pieces: 0,
        singlediscount: 0,
    };

    const AddtoListdata = (e) => {
        e.preventDefault();
        // if (qty > 0) {
        if (QtyItem > 0) {
            const quantity = parseInt(QtyItem);
            //const bundleSize = parseInt(newItem.Bundle);
            const bundleSize = parseInt(newItem.Bundle) || 0; // Default to 1 if Bundle is null or 0

            // Calculate number of bundles and remaining pieces
            // Check if bundleSize is valid (not null or 0)
            const numBundles = bundleSize ? Math.floor(quantity / bundleSize) : 0;
            const pieceCount = bundleSize ? quantity % bundleSize : 0;


            // Your existing calculations
            // const rateperkg = rate / newItem.weight;
            const rateperkg = rate;
            const totalQuantity = newItem.weight * quantity;
            const totalAmount = rate * quantity;
            const TotalAmtperkgwise = rateperkg * totalQuantity;
            const TaxableAmount = truncate2(((rateperkg - discount) * totalQuantity * 100) / (100 + GSTRate));
            const gstAmount = truncate2((TaxableAmount * GSTRate) / 100);
            const GstPer = (gstAmount / TaxableAmount) * 100;
            const totalPlusGst = Math.round(TaxableAmount + gstAmount);

            const updatedItem = {
                ...newItem,
                Name: selectedItem.label,
                Id: selectedItem.value,
                quantity: quantity,
                rate: rate,
                GSTRate: GSTRate,
                totalAmount: totalAmount,
                totalPlusGst: totalPlusGst,
                discount: discount,
                totalQuantity: totalQuantity,
                rateperkg: rateperkg,
                TotalAmtperkgwise: TotalAmtperkgwise,
                TaxableAmount: TaxableAmount,
                gstAmount: gstAmount,
                GstPer: GstPer,
                Bundle: numBundles,
                Pieces: pieceCount,
                QtyBundle: QtyBundle,
            };

            // Updating state
            setItemList([...itemList, updatedItem]);

            // Resetting newItem state
            setNewItem({
                Id: '',
                Name: '',
                quantity: 1,
                GSTRate: 0,
                rate: 0,
                totalAmount: 0,
                totalPlusGst: 0,
                discount: 0,
                weight: 0,
                totalQuantity: 0,
                rateperkg: 0,
                TotalAmtperkgwise: 0,
                GstPer: 0,
                gstAmount: 0,
                TaxableAmount: 0,
                Bundle: 0,
                pieces: 0,
            });

            // Resetting other state variables
            setNewItem({ ...defaultItem });
            setSelectedItem('');
            setQty('');
            setRate('');
            setGSTRate(0);
            setBundle('');
        }
    };

    const handleDiscountChange = (e, index) => {
        const value = parseFloat(e.target.value) || 0;
        const updatedItems = [...itemList];
        updatedItems[index].singlediscount = value;

        const TotalQuantity = updatedItems[index].totalQuantity || 0;
        const rateperkg = updatedItems[index].rateperkg || 0;
        const totalAmount = updatedItems[index].rate * updatedItems[index].quantity;
        const TotalAmtperkgwise = rateperkg * TotalQuantity;
        const TaxableAmount = truncate2((((rateperkg - value) * TotalQuantity * 100) / (100 + updatedItems[index].GSTRate)) || 0);
        const gstAmount = truncate2((TaxableAmount * updatedItems[index].GSTRate / 100) || 0);
        const GstPer = (TaxableAmount !== 0) ? (gstAmount / TaxableAmount * 100) : 0;
        const totalPlusGst = Math.round(TaxableAmount + gstAmount);

        updatedItems[index].totalPlusGst = totalPlusGst;
        updatedItems[index].discount = value;
        updatedItems[index].gstAmount = gstAmount;
        updatedItems[index].GstPer = GstPer;
        updatedItems[index].TaxableAmount = TaxableAmount;
        setItemList(updatedItems);
    };

    const handleQuantityChange = (e, index) => {
        const { value } = e.target;
        const updatedItems = [...itemList];
        const quantity = parseInt(value, 10);
        updatedItems[index].quantity = quantity;
    
        let bundleSize = 0;
        const DiscountPerPiece = updatedItems[index].DiscountPerPiece || 0;
        const bag = updatedItems[index].BagWeight || 0;
        const bagweight = updatedItems[index].weight || 0;
        let BagWeight = 0;
    
        if (bag > 0) {
          BagWeight = bag;
          bundleSize = parseInt(updatedItems[index].BundleAndPiece) || 0;
        } else if (bagweight > 0) {
          BagWeight = bagweight;
          bundleSize = parseInt(updatedItems[index].QtyBundle) || 0;
        }
    
        const rateperkg = updatedItems[index].rateperkg || 0;
    
        const numBundles = bundleSize ? Math.floor(quantity / bundleSize) : 0;
        const pieceCount = bundleSize ? quantity % bundleSize : 0;
        // Calculate Total Quantity (Kgs)
        const TotalQuantity = BagWeight * quantity;
        updatedItems[index].totalQuantity = TotalQuantity;
    
        const RateAfterDiscount = rateperkg - DiscountPerPiece;
        updatedItems[index].RateAfterDiscount = RateAfterDiscount;
    
        const TaxableAmount = truncate2(((RateAfterDiscount * TotalQuantity * 100) / (100 + updatedItems[index].GSTRate)) || 0);
        updatedItems[index].TaxableAmount = TaxableAmount;
    
        const gstAmount = truncate2((TaxableAmount * updatedItems[index].GSTRate / 100) || 0);
        updatedItems[index].gstAmount = gstAmount;
    
        const totalPlusGst = Math.round(TaxableAmount + gstAmount);
        updatedItems[index].totalPlusGst = totalPlusGst;
    
        const totalAmount = RateAfterDiscount * quantity;
        updatedItems[index].totalAmount = totalAmount;
    
        updatedItems[index].Bundle = numBundles;
        updatedItems[index].Pieces = pieceCount;
    
        console.log("Updated Item:", updatedItems[index]); // Debug log to check updated values
    
        setItemList(updatedItems); // This should trigger a re-render with the updated state
      };
    
    const submitData = async (e) => {
        e.preventDefault();
        try {
            const itemsToSave = itemList.map(item => ({
                ItemId: item.Id,
                CustomerId: customerId,
                CompanyId: companyId,
                CategoryId: categoryId,
                ProductCategoryId: productCategoryId,
                rate: item.Rate,
                Quantity: item.quantity,
                Discount: item.discount ? item.discount : 0,
                BilledDate: new Date(),
                CreatedBy: userId,
                CreatedDate: new Date(),
                RatePerKg: item.rateperkg,
                DiscountPerPiece: item.singlediscount ? item.singlediscount : 0,
                RateAfterDiscount: (item.rateperkg - item.singlediscount),
                TotalQty: item.totalQuantity,
                BagWeight: item.weight,
                CGSTAmt: (item.gstAmount / 2),
                SGSTAmt: (item.gstAmount / 2),
                GSTAmt: item.gstAmount,
                TaxableAmt: item.TaxableAmount,
                NetAmt: item.totalPlusGst,
                Bundle: item.Bundle,
                Pieces: item.Pieces

            }));

            const saleorderdata = {
                TripId: tid,
                CustomerId: customerId,
                OrderDate: tripdate,
                SaleRemarks: SaleRemarks,
                CreatedBy: userId,
                CompanyId: companyId,
                CreatedDate: new Date(),
                OrderType: 1,
            };

            const CreateData = {
                SaleOrder: saleorderdata,
                SaleOrderDetails: itemsToSave,
            };

            // Show a confirmation dialog before submitting the order
            const confirmOrder = window.confirm('Are you sure you want to confirm the order?');
            if (confirmOrder) {
                postData('ExtraLoadingAPI', CreateData, token)
                    .then((response) => {
                        if (response.response === '1111') {
                            const SaleOrderid = response.SaleOrderId;
                            history.push(`/ExtraLoadingSaleIndex`);
                        }
                    })
                    .catch((error) => {
                        console.error('SaleOrder Create error:', error);
                    });
            }
        } catch (error) {
            console.error('Submit error:', error);
        }
    };

    const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    const openConfirmDialog = (index) => {
        setItemToDeleteIndex(index);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setItemToDeleteIndex(null);

    };

    const handleDelete = () => {
        if (itemToDeleteIndex !== null) {
            const updatedItemList = itemList.filter((_, i) => i !== itemToDeleteIndex);
            setItemList(updatedItemList);
            closeConfirmDialog();
        }
    };

    const [showModal, setShowModal] = useState(false);
    const [filteredData, setFilteredData] = useState([]);

    const opendatamodal = () => {
        handleHistoryClick(id);
        setShowModal(true);
    };

    const handleHistoryClick = async (id) => {
        try {
            const response = await fetchData('OrderSummaryApi', `/${companyId}/${id}`, token);
            if (response.responseCode === '1111') {
                setFilteredData(response.response_data);
                setShowModal(true);
                // console.log('Modal state set to true:', showModal);
            } else {
                console.error('Invalid response code:', response.responseCode);
            }
        } catch (error) {
            console.error('Error fetching Order Items:', error);
        }
    };

    const closeModal = () => {
        console.log('Closing modal');
        setShowModal(false);
    };

    return (
        <div style={{ maxWidth: '100%', backgroundColor: '#f3edf8', padding: '12px' }}>
            <div style={{ backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 2px 12px rgba(107,76,122,0.10)', overflow: 'hidden' }}>
                {loading && (
                    <div style={{
                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                        backgroundColor: 'rgba(107, 76, 122, 0.18)', backdropFilter: 'blur(3px)',
                        display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                    }}>
                        <div style={{
                            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px',
                            backgroundColor: 'white', borderRadius: '12px', padding: '24px 40px',
                            boxShadow: '0 8px 32px rgba(107,76,122,0.18)'
                        }}>
                            <CircularProgress style={{ color: '#6b4c7a' }} size={36} thickness={4} />
                            <span style={{ color: '#6b4c7a', fontSize: '13px', fontWeight: 600 }}>Loading...</span>
                        </div>
                    </div>
                )}
                <form onSubmit={submitData}>
                    {/* ── Header Bar ── */}
                    <div style={{
                        background: 'linear-gradient(135deg, #6b4c7a 0%, #9b6dac 100%)',
                        padding: '10px 16px',
                        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    }}>
                        <div>
                            <h2 style={{ margin: 0, fontSize: '14px', fontWeight: 700, color: 'white', letterSpacing: '0.8px', textTransform: 'uppercase' }}>
                                ➕ Extra Loading Create
                            </h2>
                            <div style={{ marginTop: '2px', fontSize: '11px', color: 'rgba(255,255,255,0.8)' }}>
                                {customerName} {addressLine1} &nbsp;|&nbsp; Route: <strong style={{ color: 'white' }}>{Route}</strong>
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <Button variant="contained" color="secondary" onClick={() => opendatamodal()}
                                style={{ height: '32px', fontSize: '11px', fontWeight: 700, borderRadius: '16px', textTransform: 'none', padding: '0 12px' }}>
                                Summary
                            </Button>
                            <Button variant="contained" type="submit"
                                style={{ height: '32px', fontSize: '11px', fontWeight: 700, backgroundColor: '#10a37f', color: 'white', borderRadius: '16px', textTransform: 'none', padding: '0 14px', boxShadow: '0 2px 6px rgba(16,163,127,0.4)' }}>
                                ✓ Order Confirm
                            </Button>
                            <Tooltip title="Back To List">
                                <Link to={`/ExtraLoadingSaleIndex/${tid}`} style={{ textDecoration: 'none' }}>
                                    <Button variant="contained" style={{
                                        height: '32px', fontSize: '11px', fontWeight: 700,
                                        backgroundColor: 'rgba(255,255,255,0.15)', color: 'white',
                                        borderRadius: '16px', textTransform: 'none',
                                        border: '1px solid rgba(255,255,255,0.4)', boxShadow: 'none',
                                        padding: '0 12px',
                                    }}>
                                        Back <ExitToAppIcon style={{ marginLeft: '3px', fontSize: '14px' }} />
                                    </Button>
                                </Link>
                            </Tooltip>
                        </div>
                    </div>

                    <div style={{ padding: '10px 14px' }}>
                        {/* ── Info Cards ── */}
                        <div style={{
                            display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: '8px',
                            marginBottom: '8px', padding: '10px 12px',
                            backgroundColor: '#faf8fc', borderRadius: '8px', border: '1px solid #e8dff0',
                        }}>
                            {[
                                { label: 'Last Bill Date', value: LastBillDate && new Date(LastBillDate).toLocaleDateString('en-GB') },
                                { label: 'Last Bill Amt', value: LastBillAmount },
                                { label: 'Outstanding', value: Outstanding },
                                { label: 'Order Date', value: tripdate && new Date(tripdate).toLocaleDateString('en-GB') },
                                { label: 'Price Type', value: pricetype },
                                { label: 'Payment Mode', value: paymentMode },
                            ].map((info, i) => (
                                <div key={i} style={{ textAlign: 'center' }}>
                                    <div style={{ fontSize: '9px', color: '#6b4c7a', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.3px' }}>{info.label}</div>
                                    <div style={{ fontSize: '12px', fontWeight: 600, color: '#2c3e50', marginTop: '2px' }}>{info.value || '—'}</div>
                                </div>
                            ))}
                        </div>

                        {/* ── Remarks + Add Item ── */}
                        <div style={{
                            padding: '10px 12px', backgroundColor: '#faf8fc',
                            borderRadius: '8px', border: '1px solid #e8dff0', marginBottom: '10px',
                        }}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 120px auto', gap: '10px', alignItems: 'flex-end' }}>
                                <div>
                                    <label style={{ display: 'block', fontSize: '10px', fontWeight: 700, color: '#6b4c7a', marginBottom: '4px', textTransform: 'uppercase' }}>📝 Remarks</label>
                                    <input value={SaleRemarks} onChange={(e) => setSaleRemarks(e.target.value)} type="text" placeholder="Enter remark..."
                                        style={{ width: '100%', height: '32px', padding: '0 10px', fontSize: '12px', border: '1.5px solid #e0d4ec', borderRadius: '6px', outline: 'none', boxSizing: 'border-box' }}
                                        onFocus={e => e.target.style.borderColor = '#6b4c7a'}
                                        onBlur={e => e.target.style.borderColor = '#e0d4ec'} />
                                </div>
                                <div>
                                    <label style={{ display: 'block', fontSize: '10px', fontWeight: 600, color: '#555', marginBottom: '4px' }}>Variant with Bagweight</label>
                                    <Select options={itemOptions} onChange={handleItemChange} placeholder="Select Item" menuPortalTarget={document.body}
                                        styles={{
                                            control: (base, state) => ({ ...base, fontSize: '12px', minHeight: '32px', height: '32px', borderColor: state.isFocused ? '#6b4c7a' : '#e0d4ec', borderRadius: '6px', boxShadow: 'none', '&:hover': { borderColor: '#6b4c7a' } }),
                                            valueContainer: (base) => ({ ...base, padding: '0 8px' }),
                                            indicatorsContainer: (base) => ({ ...base, height: '32px' }),
                                            option: (base, state) => ({ ...base, fontSize: '12px', padding: '6px 10px', backgroundColor: state.isSelected ? '#6b4c7a' : state.isFocused ? '#f3edf8' : 'white' }),
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        }} />
                                </div>
                                <div>
                                    <label style={{ display: 'block', fontSize: '10px', fontWeight: 600, color: '#555', marginBottom: '4px' }}>QTY (Pieces)</label>
                                    <input type="number" min={1}
                                        value={QtyItem}
                                        onChange={(e) => { let v = parseInt(e.target.value, 10); if (isNaN(v) || v < 1) v = 1; setQtyItem(v); }}
                                        onClick={(e) => e.target.select()}
                                        style={{ width: '100%', height: '32px', padding: '0 10px', fontSize: '12px', fontWeight: 600, border: '1.5px solid #e0d4ec', borderRadius: '6px', textAlign: 'center', outline: 'none', boxSizing: 'border-box' }}
                                        onFocus={e => e.target.style.borderColor = '#6b4c7a'}
                                        onBlur={e => e.target.style.borderColor = '#e0d4ec'} />
                                </div>
                                <div>
                                    <Button variant="contained" onClick={AddtoListdata}
                                        style={{ height: '32px', fontSize: '11px', fontWeight: 700, backgroundColor: '#6b4c7a', color: 'white', borderRadius: '6px', textTransform: 'none', padding: '0 14px', boxShadow: '0 2px 6px rgba(107,76,122,0.3)', whiteSpace: 'nowrap' }}>
                                        + Add
                                    </Button>
                                </div>
                            </div>
                        </div>

                        {/* ── Items Table ── */}
                        <div style={{ borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 10px rgba(107,76,122,0.12)', border: '1px solid #e0d6e8' }}>
                            <div style={{ overflowX: 'auto', maxHeight: '420px', overflowY: 'auto' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                                    <colgroup>
                                        <col style={{ width: '3%' }} />
                                        <col style={{ width: '15%' }} />
                                        <col style={{ width: '7%' }} />
                                        <col style={{ width: '7%' }} />
                                        <col style={{ width: '6%' }} />
                                        <col style={{ width: '6%' }} />
                                        <col style={{ width: '8%' }} />
                                        <col style={{ width: '7%' }} />
                                        <col style={{ width: '8%' }} />
                                        <col style={{ width: '9%' }} />
                                        <col style={{ width: '5%' }} />
                                        <col style={{ width: '8%' }} />
                                        <col style={{ width: '8%' }} />
                                        <col style={{ width: '3%' }} />
                                    </colgroup>
                                    <thead style={{ position: 'sticky', top: 0, zIndex: 2 }}>
                                        <tr style={{ backgroundColor: '#6b4c7a' }}>
                                            {[
                                                { label: '#', align: 'center' },
                                                { label: 'Name', align: 'left' },
                                                { label: 'Qty', sub: 'No.Pieces', align: 'center' },
                                                { label: 'Total Qty', sub: 'Kgs', align: 'right' },
                                                { label: 'Bundle', align: 'center' },
                                                { label: 'Pieces', align: 'center' },
                                                { label: 'Rate/Kg', sub: 'Incl.Tax', align: 'right' },
                                                { label: 'Discount', align: 'right' },
                                                { label: 'Rate', sub: 'After Disc.', align: 'right' },
                                                { label: 'Taxable Amt', align: 'right' },
                                                { label: 'GST%', align: 'center' },
                                                { label: 'GST (₹)', align: 'right' },
                                                { label: 'Total', align: 'right' },
                                                { label: '', align: 'center' },
                                            ].map((col, i) => (
                                                <th key={i} style={{ color: 'white', fontWeight: 700, fontSize: '11px', padding: '10px 8px', textAlign: col.align, whiteSpace: 'nowrap', borderRight: i < 13 ? '1px solid rgba(255,255,255,0.18)' : 'none', letterSpacing: '0.3px', lineHeight: '1.3' }}>
                                                    {col.label}{col.sub && <><br /><span style={{ fontSize: '9px', fontWeight: 400, opacity: 0.85 }}>{col.sub}</span></>}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {itemList.length === 0 ? (
                                            <tr><td colSpan={14} style={{ textAlign: 'center', padding: '28px', color: '#aaa', fontSize: '13px', fontStyle: 'italic' }}>No items added yet.</td></tr>
                                        ) : (
                                            itemList.map((item, index) => {
                                                const rowBg = index % 2 === 0 ? '#faf8fc' : '#ffffff';
                                                const inputStyle = { width: '100%', textAlign: 'right', padding: '4px 6px', fontSize: '11px', border: '1px solid #d0c4dc', borderRadius: '4px', backgroundColor: '#fff', outline: 'none', boxSizing: 'border-box' };
                                                return (
                                                    <tr key={index} style={{ backgroundColor: rowBg, borderBottom: '1px solid #ede7f3' }}
                                                        onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f3edf8'}
                                                        onMouseLeave={e => e.currentTarget.style.backgroundColor = rowBg}>
                                                        <td style={{ fontSize: '11px', padding: '8px', textAlign: 'center', color: '#888', borderRight: '1px solid #ede7f3' }}>{index + 1}</td>
                                                        <td style={{ fontSize: '12px', padding: '8px', fontWeight: 600, color: '#3d2459', borderRight: '1px solid #ede7f3', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={item.Name}>{item.Name}</td>
                                                        <td style={{ padding: '6px', borderRight: '1px solid #ede7f3' }}>
                                                            <input type="number" value={item.quantity} onChange={(e) => handleQuantityChange(e, index)} min="0" step="1" style={inputStyle} onClick={(e) => e.target.select()} />
                                                        </td>
                                                        <td style={{ fontSize: '11px', padding: '8px', textAlign: 'right', color: '#333', borderRight: '1px solid #ede7f3' }}>{item.totalQuantity}</td>
                                                        <td style={{ fontSize: '11px', padding: '8px', textAlign: 'center', borderRight: '1px solid #ede7f3' }}>
                                                            <span style={{ background: '#ede7f3', borderRadius: '10px', padding: '1px 8px', fontWeight: 600 }}>{item.Bundle}</span>
                                                        </td>
                                                        <td style={{ fontSize: '11px', padding: '8px', textAlign: 'center', borderRight: '1px solid #ede7f3' }}>
                                                            <span style={{ background: '#e8f4fd', borderRadius: '10px', padding: '1px 8px', fontWeight: 600 }}>{item.Pieces}</span>
                                                        </td>
                                                        <td style={{ fontSize: '11px', padding: '8px', textAlign: 'right', borderRight: '1px solid #ede7f3' }}>{item.rateperkg}</td>
                                                        <td style={{ padding: '6px', borderRight: '1px solid #ede7f3' }}>
                                                            <input type="number" value={(isNaN(item.singlediscount) || item.singlediscount === '') ? '0' : item.singlediscount} onChange={(e) => handleDiscountChange(e, index)} step="0.01" min="0" style={inputStyle} onClick={(e) => e.target.select()} />
                                                        </td>
                                                        <td style={{ fontSize: '11px', padding: '8px', textAlign: 'right', color: '#1a7a4a', fontWeight: 600, borderRight: '1px solid #ede7f3' }}>
                                                            {(isNaN(item.rateperkg - item.singlediscount) ? 0 : item.rateperkg - item.singlediscount).toFixed(2)}
                                                        </td>
                                                        <td style={{ fontSize: '11px', padding: '8px', textAlign: 'right', borderRight: '1px solid #ede7f3' }}>{item.TaxableAmount.toFixed(2)}</td>
                                                        <td style={{ fontSize: '11px', padding: '8px', textAlign: 'center', borderRight: '1px solid #ede7f3' }}>
                                                            <span style={{ background: '#fff8e1', color: '#b8860b', borderRadius: '10px', padding: '1px 7px', fontWeight: 600, fontSize: '10px' }}>{item.GSTRate}%</span>
                                                        </td>
                                                        <td style={{ fontSize: '11px', padding: '8px', textAlign: 'right', color: '#c0392b', borderRight: '1px solid #ede7f3' }}>{item.gstAmount.toFixed(2)}</td>
                                                        <td style={{ fontSize: '12px', padding: '8px', textAlign: 'right', fontWeight: 700, color: '#2c3e50', borderRight: '1px solid #ede7f3' }}>{item.totalPlusGst.toFixed(2)}</td>
                                                        <td style={{ padding: '6px', textAlign: 'center' }}>
                                                            <IconButton size="small" onClick={() => openConfirmDialog(index)} style={{ padding: '4px', color: '#e53935', backgroundColor: '#fdecea', borderRadius: '6px' }}>
                                                                <DeleteIcon style={{ fontSize: '16px' }} />
                                                            </IconButton>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                    <tfoot>
                                        <tr style={{ backgroundColor: '#6b4c7a', color: 'white', fontWeight: 700 }}>
                                            <td colSpan={2} style={{ fontSize: '12px', padding: '10px 8px', borderRight: '1px solid rgba(255,255,255,0.2)' }}>TOTAL</td>
                                            <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'right', borderRight: '1px solid rgba(255,255,255,0.2)' }}>{itemList.reduce((acc, i) => acc + i.quantity, 0)}</td>
                                            <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'right', borderRight: '1px solid rgba(255,255,255,0.2)' }}>{itemList.reduce((acc, i) => acc + i.totalQuantity, 0)}</td>
                                            <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'center', borderRight: '1px solid rgba(255,255,255,0.2)' }}>{itemList.reduce((acc, i) => acc + i.Bundle, 0)}</td>
                                            <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'center', borderRight: '1px solid rgba(255,255,255,0.2)' }}>{itemList.reduce((acc, i) => acc + i.Pieces, 0)}</td>
                                            <td style={{ padding: '10px 8px', borderRight: '1px solid rgba(255,255,255,0.2)' }}>—</td>
                                            <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'right', borderRight: '1px solid rgba(255,255,255,0.2)' }}>{itemList.reduce((acc, i) => acc + (Number(i.singlediscount) || 0), 0).toFixed(2)}</td>
                                            <td style={{ padding: '10px 8px', borderRight: '1px solid rgba(255,255,255,0.2)' }}>—</td>
                                            <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'right', borderRight: '1px solid rgba(255,255,255,0.2)' }}>{itemList.reduce((acc, i) => acc + i.TaxableAmount, 0).toFixed(2)}</td>
                                            <td style={{ padding: '10px 8px', borderRight: '1px solid rgba(255,255,255,0.2)' }}>—</td>
                                            <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'right', borderRight: '1px solid rgba(255,255,255,0.2)' }}>{itemList.reduce((acc, i) => acc + i.gstAmount, 0).toFixed(2)}</td>
                                            <td style={{ fontSize: '13px', padding: '10px 8px', textAlign: 'right', borderRight: '1px solid rgba(255,255,255,0.2)', backgroundColor: '#4a2d5a' }}>{itemList.reduce((acc, i) => acc + i.totalPlusGst, 0).toFixed(2)}</td>
                                            <td style={{ padding: '10px 8px' }}></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>

                        {/* Delete Confirm Dialog */}
                        <Dialog open={confirmDialogOpen} onClose={closeConfirmDialog} PaperProps={{ style: { borderRadius: '12px', padding: '8px' } }}>
                            <DialogTitle style={{ color: '#6b4c7a', fontWeight: 700 }}>Delete Record?</DialogTitle>
                            <DialogContent>
                                <DialogContentText style={{ fontSize: '13px' }}>Are you sure you want to delete this item?</DialogContentText>
                            </DialogContent>
                            <DialogActions style={{ padding: '8px 16px 16px' }}>
                                <button onClick={closeConfirmDialog} style={{ backgroundColor: '#dc3545', color: '#fff', border: 'none', borderRadius: '6px', padding: '8px 20px', cursor: 'pointer', fontWeight: 600 }}>Cancel</button>
                                <button onClick={() => handleDelete(itemToDeleteIndex)} style={{ backgroundColor: '#28a745', color: '#fff', border: 'none', borderRadius: '6px', padding: '8px 20px', cursor: 'pointer', fontWeight: 600, marginLeft: '8px' }}>Confirm</button>
                            </DialogActions>
                        </Dialog>

                    </div>
                </form>

                {/* Summary Modal — keep existing implementation */}
                {showModal && (
                    <Modal open={showModal} className={showModal ? 'notification-modal' : ''}>
                        <div className="fixed inset-0 flex items-start justify-center z-10">
                            <div className="bg-green-100 p-6 rounded-lg shadow-lg" style={{ width: '1000px', maxHeight: '80vh', overflowY: 'auto', overflowX: 'auto', marginTop: '50px' }}>
                                <div className="flex justify-end mt-2">
                                    <button className="close-button md:static md:mr-2" onClick={closeModal} style={{ marginTop: '-10px', color: 'black' }}>
                                        <Tooltip title="Close"><FaTimes /></Tooltip>
                                    </button>
                                </div>
                                <TableContainer component={Paper} style={{ marginTop: '15px' }}>
                                    <Table>
                                        <TableHead sx={{ backgroundColor: '#58A566' }}>
                                            <TableRow>
                                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '5px', color: 'whitesmoke', width: '30px', textAlign: 'center' }}>Sl.No</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '5px', color: 'whitesmoke', width: '50px', textAlign: 'center' }}>Invoice Date</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '5px', color: 'whitesmoke', textAlign: 'left' }}>Item Name</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '5px', color: 'whitesmoke', textAlign: 'center' }}>Total Quantity</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '5px', color: 'whitesmoke', textAlign: 'center' }}>Net Amount</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '5px', color: 'whitesmoke', textAlign: 'center' }}>Total CGST Amount</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '5px', color: 'whitesmoke', textAlign: 'center' }}>Total SGST Amount</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '5px', color: 'whitesmoke', textAlign: 'center' }}>Total Discount Amount</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '5px', color: 'whitesmoke', textAlign: 'center' }}>Total Amount</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody sx={{ backgroundColor: '#9BC1B3' }}>
                                            {filteredData && filteredData.length > 0 && (
                                                filteredData.reduce((acc, item, index, array) => {
                                                    const currentDayTotal = array.filter(data => data.InvoiceDate === item.InvoiceDate).reduce((sum, data) => sum + data.TotalAmount, 0);
                                                    acc.push(
                                                        <TableRow key={item.id}>
                                                            <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', width: '50px', textAlign: 'center' }}>{index + 1}</TableCell>
                                                            <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', width: '50px', textAlign: 'center' }}>{item.InvoiceDate && new Date(item.InvoiceDate).toLocaleDateString('en-GB')}</TableCell>
                                                            <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'left' }}>{item.ItemName}</TableCell>
                                                            <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'center' }}>{item.TotalQuantity}</TableCell>
                                                            <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'center' }}>{item.NetAmount.toFixed(2)}</TableCell>
                                                            <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'center' }}>{item.TotalCGSTAmount.toFixed(2)}</TableCell>
                                                            <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'center' }}>{item.TotalSGSTAmount.toFixed(2)}</TableCell>
                                                            <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'center' }}>{item.TotalDiscountAmount}</TableCell>
                                                            <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'center' }}>{item.TotalAmount.toFixed(2)}</TableCell>
                                                        </TableRow>
                                                    );
                                                    if (index === array.length - 1 || item.InvoiceDate !== array[index + 1].InvoiceDate) {
                                                        acc.push(
                                                            <TableRow key={`total-${item.InvoiceDate}`}>
                                                                <TableCell colSpan={9} sx={{ borderBottom: '1px solid #F5F5F5', backgroundColor: '#201658', color: 'white', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'center' }}>Total: {currentDayTotal.toFixed(2)}</TableCell>
                                                            </TableRow>
                                                        );
                                                    }
                                                    return acc;
                                                }, [])
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </div>
                    </Modal>
                )}
            </div>
        </div>
    );
};

export default ExtraSaleOrderCreate;
